import { render, staticRenderFns } from "./UpdateOrganizationOwnerPopup.vue?vue&type=template&id=1d94c133&"
import script from "./UpdateOrganizationOwnerPopup.vue?vue&type=script&lang=ts&"
export * from "./UpdateOrganizationOwnerPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports